<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 0">
                <base-button v-if="currentProfile == 'general_inventory_report_advances'" slot="title" type="warning" class="dropdown-toggle">
                    Basic Inventories Reports - General Inventory Reports (Advance)
                </base-button>
                <base-button v-else slot="title" type="warning" class="dropdown-toggle">
                    Basic Inventories Reports - {{_.startCase(currentProfile)}}
                </base-button>
                <a v-for="profile in activeModules" :key="profile.id"
                    @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)"
                    class="dropdown-item" href="#">{{profile.name}}</a>
            </base-dropdown>
            <base-dropdown v-else>
                <base-button slot="title" type="primary" class="dropdown-toggle">
                    Basic Inventories Reports
                </base-button>
                <a class="dropdown-item" disabled>No active module/s under this feature</a>
            </base-dropdown>
        </base-header>
        <!-- <img style="display: none;" id='reportLogo' :src="imagepath" alt='Report Logo' crossorigin="anonymous"/> -->
        <div id="logoDiv" style="display: none;"></div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <item-returns-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'item_returns_reports'"></item-returns-report>
                    <item-sales-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'item_sales_reports'"></item-sales-report>
                    <matrix-sales-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'matrix_sales_reports'"></matrix-sales-report>
                    <category-sales-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'category_sales_reports'"></category-sales-report>
                    <category-returns-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'category_returns_reports'"></category-returns-report>
                    <stock-valuation-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'stock_valuation_reports'"></stock-valuation-report>
                    <stock-valuation-summary :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'stock_valuation_summaries'"></stock-valuation-summary>
                    <StockValuationReportWithCost :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'stock_valuation_report_with_costs'"/>
                    <StockValuationSummaryWithCost :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'stock_valuation_summary_with_costs'"/>
                    <general-inventory-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'general_inventory_report_advances'"></general-inventory-report>
                    <inventory-cost-layer-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'inventory_cost_layer_reports'"></inventory-cost-layer-report>
                    <item-sales-profit :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'item_sales_profits'"></item-sales-profit>
                    <inventory-aging-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'inventory_aging_reports'"></inventory-aging-report>
                    <inventory-aging-valuation :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'inventory_aging_valuations'"></inventory-aging-valuation>
                    <PhysicalCountVarianceReport :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'physical_count_variance_reports'"/>
                    <stock-activity-valuation :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'stock_activity_valuations'"></stock-activity-valuation>
                    <oms-collection-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'oms_collection_reports'"></oms-collection-report>
                    <oms-daily-sales-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'oms_daily_sales_reports'"></oms-daily-sales-report>
                    <serial-item-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'serial_item_reports'"></serial-item-report>
                    <serial-tracking-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'serial_tracking_reports'"></serial-tracking-report>
                    <general-inventory-with-packing-breakdown-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'general_inventory_with_packing_breakdown_reports'"></general-inventory-with-packing-breakdown-report>
                    <product-expiration-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'product_expiration_reports'"></product-expiration-report>
                    <basic-general-inventory-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'basic_inventory_reports'"></basic-general-inventory-report>
                    <MinMaxReport :access_rights="accessRights" v-if="currentProfile == 'min_max_reports'"></MinMaxReport>
                    <unposted-documents-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'unposted_document_reports'"></unposted-documents-report>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from "axios";
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import ItemReturnsReport from '../Basic Sales Reports/ItemReturnsReport';
    import ItemSalesReport from '../Basic Sales Reports/ItemSalesReport';
    import MatrixSalesReport from '../Basic Sales Reports/MatrixSalesReport';
    import CategorySalesReport from '../Basic Sales Reports/CategorySalesReport';
    import CategoryReturnsReport from '../Basic Sales Reports/CategoryReturnsReport';
    import StockValuationReport from '../Basic Sales Reports/StockValuationReport';
    import StockValuationSummary from '../Basic Sales Reports/StockValuationSummary';
    import StockValuationReportWithCost from '../Basic Inventory Reports/StockValuationReportWithCost';
    import StockValuationSummaryWithCost from '../Basic Inventory Reports/StockValuationSummaryWithCost';
    import GeneralInventoryReport from '../Basic Sales Reports/GeneralInventoryReport';
    import ItemSalesProfit from '../Basic Sales Reports/ItemSalesProfit';
    import InventoryAgingReport from '../Basic Sales Reports/InventoryAgingReport';
    import InventoryAgingValuation from '../Basic Sales Reports/InventoryAgingValuation';
    import PhysicalCountVarianceReport from '../Basic Inventory Reports/PhysicalCountVarianceReport';
    import StockActivityValuation from '../Basic Sales Reports/StockActivityValuation';
    import OmsCollectionReport from '../Basic Sales Reports/OmsCollectionReport';
    import OmsDailySalesReport from '../Basic Sales Reports/OmsDailySalesReport';
    import SerialItemReport from '../Basic Sales Reports/SerialItemReport';
    import SerialTrackingReport from '../Basic Sales Reports/SerialTrackingReport';
    import GeneralInventoryWithPackingBreakdownReport from '../Basic Sales Reports/GeneralInventoryWithPackingBreakdownReport';
    import ProductExpirationReport from '../Basic Inventory Reports/ProductExpirationReport';
    import InventoryCostLayerReport from '../Basic Sales Reports/InventoryCostLayerReport';
    import BasicGeneralInventoryReport from '../Basic Sales Reports/BasicGeneralInventoryReport';
    import MinMaxReport from '../Basic Inventory Reports/MinMaxReport';
    import UnpostedDocumentsReport from '../Basic Inventory Reports/UnpostedDocumentsReport';

    import {
        mapState,
        mapActions
    } from 'vuex'

    const STOCK_VALUATION_REQUEST_SOURCE = 'BXI-REPORT';
    const STOCK_VALUATION_PROFILE = 'stock_valuation_reports';
    const STOCK_VALUATION_ENDPOINTS = [
        'stock_valuations?',
        'stock_valuations_background?',
        'stock_valuations_background_optimize?'
    ];

    export default {
        data() {
            return {
                activeModules: [],
                accessRights: [],
                accessCostPriceRights: [],
                imagepath: secureStorage.getItem("account_logo"),
                stockValuationRequestInterceptorId: null
            }
        },
        mounted: async function () {
          let newActiveModules = [];
          var component_x = this;

            //Fix: S3 image CORS error in jsPDF
            const corsImageModified = new Image();
            corsImageModified.crossOrigin = "Anonymous";
            corsImageModified.id = "reportLogo";
            corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            document.getElementById("logoDiv").appendChild(corsImageModified);
            //Fix: S3 image CORS error in jsPDF

          var categoryId = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories?code=R-002&status=A', null, null)
          if(categoryId[0] != undefined){
            component_x.activeModules = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules', null, null)

            // Check if user has permission for Basic Inventory Reports (R-002) Physical Count - Variance Report (BI-008)
            const userActiveModulesURL = `${component_x.endPoint}/system_module_categories/user_enabled_modules?category_codes=R-002`;
            const userActiveModules = await HTTPRequest.getRequest(userActiveModulesURL, null, null);

            if (userActiveModules.enabled_modules.length > 0) {
              let activeModuleNames = [];
              userActiveModules.enabled_modules.map(module => { activeModuleNames.push(module.name) })
              // const newActiveModules = component_x.activeModules.filter(module => module.name != "Physical Count - Variance Report");
              newActiveModules = component_x.activeModules.filter(module => activeModuleNames.includes(module.name) );
              component_x.activeModules = newActiveModules;
            }

            component_x.activeModules = newActiveModules;

            if (component_x.activeModules.length > 0) {
              var profile = _.snakeCase(component_x.activeModules[0].name)
              component_x.setCurrentProfile(_.pluralize(profile), component_x.activeModules[0].id);
            } else {
              component_x.setCurrentProfile(null, null);
            }
          }
        },
        watch: {
            currentProfile: {
                immediate: true,
                handler() {
                    console.log(this.currentProfile)
                    this.updateStockValuationReportHeader();
                }
            }
        },
        beforeDestroy() {
            this.removeStockValuationReportHeader();
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components: {
            ItemReturnsReport,
            ItemSalesReport,
            MatrixSalesReport,
            CategorySalesReport,
            CategoryReturnsReport,
            StockValuationReport,
            StockValuationSummary,
            StockValuationReportWithCost,
            StockValuationSummaryWithCost,
            GeneralInventoryReport,
            ItemSalesProfit,
            InventoryAgingReport,
            InventoryAgingValuation,
            StockActivityValuation,
            OmsCollectionReport,
            OmsDailySalesReport,
            SerialItemReport,
            SerialTrackingReport,
            PhysicalCountVarianceReport,
            GeneralInventoryWithPackingBreakdownReport,
            ProductExpirationReport,
            InventoryCostLayerReport,
            BasicGeneralInventoryReport,
            MinMaxReport,
            UnpostedDocumentsReport,
        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            updateStockValuationReportHeader() {
                this.removeStockValuationReportHeader();

                if (this.currentProfile !== STOCK_VALUATION_PROFILE) return;

                this.stockValuationRequestInterceptorId = axios.interceptors.request.use(config => {
                    const requestUrl = config.url || '';
                    const isStockValuationRequest = STOCK_VALUATION_ENDPOINTS.some(endpoint => requestUrl.includes(endpoint));

                    if (isStockValuationRequest) {
                        config.headers = config.headers || {};
                        config.headers['Request-Source'] = STOCK_VALUATION_REQUEST_SOURCE;
                    }

                    return config;
                });
            },
            removeStockValuationReportHeader() {
                if (this.stockValuationRequestInterceptorId === null) return;

                axios.interceptors.request.eject(this.stockValuationRequestInterceptorId);
                this.stockValuationRequestInterceptorId = null;
            },
            async setCurrentProfile(profile, id) {
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[id]
                }else {
                    this.accessRights = []
                }

                var accessCostPriceRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=123", null)
                if (_.isEmpty(accessCostPriceRightsRequest.access_rights) == false){
                    this.accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123]
                }else {
                    this.accessCostPriceRights = []
                }
                this.updateCurrentProfile(profile);
            }
        }
    };
</script>

<style></style>
